module.exports = __webpack_public_path__ + "img/translation-skills.f7f4f06a.png";